import React, { FC } from 'react';
import { Button, IconElement, Text } from '@wix/design-system';
import styles from './ActionsGrid.scss';

export type ActionsGridItemProps = Props;

type Props = {
  title: string;
  description: string;
  buttonText: string;
  buttonIcon: IconElement;
  onClick: () => void;
};

export const ActionsGridItem: FC<Props> = ({ title, description, buttonText, buttonIcon, onClick }) => {
  return (
    <div className={styles.actionsGridItem}>
      <div className={styles.actionsGridItemContent}>
        <Text weight="bold" size="small">
          {title}
        </Text>
        <Text secondary size="tiny">
          {description}
        </Text>
      </div>
      <Button prefixIcon={buttonIcon} onClick={onClick} priority="secondary" size="small" skin="dark">
        {buttonText}
      </Button>
    </div>
  );
};
